const connections = {
    'clients.connections': 'Connecties',
    'clients.connections.add': 'Connectie toevoegen',
    'clients.connections.edit': 'Connectie bewerken',
    'clients.connections.edit.save': 'Connectie opslaan',

    'clients.connections.categories.combine': 'Combineerbare velden',
    'clients.connections.categories.draganddrop': 'Versleep de velden om te combineren',
    'clients.connections.categories.combine.complete': 'Combinaties opslaan',

    'clients.connections.categories.add': 'Categorie toevoegen',
    'clients.connections.categories.add.name': 'Naam van de nieuwe categorie',
    'clients.connections.categories.mode.combine': 'Bewerkmodus verlaten',
    'clients.connections.categories.mode.edit': 'Bewerkmodus starten',
    'clients.connections.categories.edit.name': 'Wijzig de naam van de categorie',

    'clients.connections.brands.combine': 'Combineerbare velden',
    'clients.connections.brands.draganddrop': 'Versleep de velden om te combineren',
    'clients.connections.brands.combine.complete': 'Combinaties opslaan',
    'clients.connections.brands.edit.name': 'Wijzig de naam van het merk',

    'clients.connections.brands.add': 'Merk toevoegen',
    'clients.connections.brands.add.name': 'Naam van het nieuwe merk',
    'clients.connections.brands.save': 'Merken opslaan',
    'clients.connections.brands.edit': 'Merken bewerken',


    'clients.connections.pricing.add': 'Prijzen opslaan',
    'clients.connections.pricing.edit': 'Wijzigingen opslaan',

    'clients.connections.pricing.brand': 'Merk',
    'clients.connections.pricing.category': 'Categorie',
    'clients.connections.pricing.min': 'Minimale prijs',
    'clients.connections.pricing.max': 'Maximale prijs',
    'clients.connections.pricing.marge': 'Prijsmarge ( percentage )',
    'clients.connections.pricing.vat_percentage': 'BTW-klasse',

    'clients.connections.status': 'Status',
    'clients.connections.general': 'Algemeen',
    'clients.connections.active': 'Geactiveerd',
    'clients.connections.dryrun': 'Simulatiemodus',
    'clients.connections.name': 'Naam',
    'clients.connections.webshop': 'Webshop',
    'clients.connections.store_view': 'Winkelnummer',
    'clients.connections.feed': 'Feed',
    'clients.connections.configbase': 'Basis voor configuratie',
    'clients.connections.configbase.feed': 'Feed',
    'clients.connections.configbase.webshop': 'Webshop',
    'clients.connections.variants': 'Varianten',
    'clients.connections.use_variants': 'Varianten gebruiken',
    'clients.connections.variant_match_field': 'Combineer varianten op',
    'clients.connections.vat_settings': 'BTW-instellingen',
    'clients.connections.vat_include': 'Prijs incl. BTW naar webshop',
    'clients.connections.vat_calculate': 'BTW berekenen',
    'clients.connections.vat_percentage': 'BTW-percentage',
    'clients.connections.prefix': 'Prefix voor artikelnummers',

    'clients.connections.seo.settings': 'SEO instellingen',
    'clients.connections.seo.active': 'SEO actief',

    'clients.connections.provider.settings': 'Provider instellingen',
    'clients.connections.provider.active': 'Provider actief',
    'clients.connections.provider': 'Provider',
    'clients.connections.provider.username': 'Gebruikersnaam',
    'clients.connections.provider.password': 'Wachtwoord',
    'clients.connections.provider.infobar.icecat': 'Voor een volledige werking dient het IP-adres van onze applicatie en van jouw webshop opgenomen te worden in de whitelist van IceCat. Het IP-adres van onze applicatie is: 159.69.121.84',
    'clients.connections.provider.infobar.language': 'Kies de taal voor data uit content-provider.',

    'clients.connections.notifications': 'Notificaties',
    'clients.connections.notifications.administrative': 'Administratief',

    'clients.connections.settings': 'Instellingen',
    'clients.connections.categories': 'Categorieën',
    'clients.connections.brands': 'Merken',
    'clients.connections.attributes': 'Attributen',
    'clients.connections.pricing': 'Prijzen',
    'clients.connections.all_products': 'Alle producten',
    'clients.connections.sync': 'Synchroniseren',
    'clients.connections.sync_settings': 'Synchronisatie instellingen',

    'clients.connections.synchronized': 'Gesynchroniseerd',
    'clients.connections.products.notifications': 'Meldingen',
    'clients.connections.product.edit': 'Product aanpassen',
    'clients.connections.product': 'Product',
    'clients.connections.product.name': 'Productnaam',
    'clients.connections.product.brand': 'Merk',
    'clients.connections.product.category': 'Categorie',
    'clients.connections.product.pricing': 'Prijs',
    'clients.connections.product.number': 'Productnummer',
    'clients.connections.product.select.all': 'Selecteer alle producten',
    'clients.connections.product.saving': 'Productinformatie gegevens verzenden',
    'clients.connections.product.save': 'Productinformatie opslaan',
    'clients.connections.product.show': 'Toon product in de webshop',
    'clients.connections.product.meta_title': 'SEO titel',
    'clients.connections.product.meta_description': 'SEO omschrijving',
    'clients.connections.product.meta_keywords': 'SEO trefwoorden',

    'clients.connections.product.exception': 'Uitzondering',
    'clients.connections.product.type': 'Type',
    'clients.connections.product.batch_number': 'Batchnummer',
    'clients.connections.product.row_number': 'Rijnummer',
    'clients.connections.product.unqiue_code': 'Unieke code',
    'clients.connections.product.job': 'Job',

    'clients.connections.status.queue': 'In wachtrij',
    // 'clients.connections.status.collecting': 'Producten voorbereiden',
    // 'clients.connections.status.collecting-cp': 'Content-provider: producten voorbereiden',
    'clients.connections.status.syncing': 'In synchronisatie',
    'clients.connections.status.finished': 'Gesynchroniseerd',
    'clients.connections.status.failed': 'Syncronisatie mislukt',
    // 'clients.connections.status.deleting': 'Producten verwijderen',

    'clients.connections.status.synchronizing': 'Synchronisatie',
    'clients.connections.status.updating': 'Bijwerken',
    'clients.connections.status.product_feed.downloading': 'Benodigdheden downloaden',
    'clients.connections.status.product_feed.reading': 'Producten inladen',
    'clients.connections.status.product_feed.collecting': 'Producten controleren',
    // 'clients.connections.status.product_feed.content_provider': 'Productgegevens van content provider',
    'clients.connections.status.product_feed.syncing': 'Producten synchroniseren',
    'clients.connections.status.product_feed.deleting': 'Producten opschonen',

    'clients.connections.products.edit': 'Product bewerken',

    'clients.connections.language.shopname': 'Shoptaal',
    'clients.connections.language.code': 'Taalcode',
    'clients.connections.language.icecat.language': 'Taal vanuit IceCat',
    'clients.connections.provider.language.infobar.icecat_language': 'Kies hier de taal welke ingeladen moet worden vanuit de content provider IceCat. Indien de informatie niet in deze taal beschikbaar is in IceCat worden onderstaande gekoppelde velden gebruikt voor de vertaling.',
    'clients.connections.language.related': 'Gerelateerd',
    'clients.connections.language.cross_sell': 'Soortgelijk',

    'clients.connection.customergroup.type': 'Groep type',
    'clients.connection.customergroup.options.business_to_business_price': 'Business to business prijs',
    'clients.connection.customergroup.discount': 'Korting (percentage)',
    'clients.connection.customergroup.b2b_inc': 'Business to business prijs is inc BTW',

    'clients.connections.attributes.use_as_variant': 'Variant maken op basis van deze eigenschap',

    'clients.connections.labels.settings': 'Label instellingen (alleen voor Shopware 6)',
    'clients.connections.labels.label_related': 'Gerelateerd',
    'clients.connections.labels.label_cross_sell': 'Soortgelijk',

    'clients.connections.stock.settings': 'Voorraad instellingen (alleen voor Shopware 6)',
    'clients.connections.stock.restock_time': 'Opvuldagen',
    'clients.connections.stock.clearance_sale': 'Uitverkoop',
    'clients.connections.stock.delivery_time': 'Levertijd',
};

export default connections;
